import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=161cd47f&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('161cd47f')) {
      api.createRecord('161cd47f', component.options)
    } else {
      api.reload('161cd47f', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=161cd47f&", function () {
      api.rerender('161cd47f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2b5iJXE26a1kS/JS/comp/ImgFallback.vue"
export default component.exports